import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { SECURITY_API } from "./apiRoutes";

const mutateForgotPassword = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${SECURITY_API}/forgot-password`, data);
};

const useForgotPasswordMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateForgotPassword,
    ...queryParams,
  });

export default useForgotPasswordMutation;
